const Yellow = {
    title: 'Yellow',
    background: 'radial-gradient(circle, #ded6a0 0%, #dbcf81 100%)',
    colors: {
        primary: '#b09c17',
        secondary: '#ab9f4f',
        terciary: '#9e9660',
        fourth: '#fffbe0',
        fifth: '#fcfaeb'
    }
};

export default Yellow;